import { render, staticRenderFns } from "./CreateOrAddUsersToGroup.vue?vue&type=template&id=b8a3f800&scoped=true"
import script from "./CreateOrAddUsersToGroup.vue?vue&type=script&lang=js"
export * from "./CreateOrAddUsersToGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateOrAddUsersToGroup.vue?vue&type=style&index=0&id=b8a3f800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a3f800",
  null
  
)

export default component.exports